// extracted by mini-css-extract-plugin
export default {"base":"ResultRow_base__w1H2t"};